(function(){
  // Utilidad: cuando cambie la URL por pushState/replaceState o back/forward
  (function(history){
    if (history.__itgpPatched) return; history.__itgpPatched = true;
    const fire = () => window.dispatchEvent(new Event('itgp:urlchange'));
    const PS = history.pushState, RS = history.replaceState;
    history.pushState = function(){ const r = PS.apply(this, arguments); fire(); return r; };
    history.replaceState = function(){ const r = RS.apply(this, arguments); fire(); return r; };
    window.addEventListener('popstate', fire);
  })(window.history);

  const TXT = {
    inStockMany: 'Hay plazas',
    inStockFew:  qty => '¡Quedan ' + qty + ' plazas!',
    none:        'Sin plazas',
    available:   'Disponible'
  };

  function setMsg(container, text){
    const el = container.querySelector('[data-inventory-msg]');
    if (el) el.textContent = text; else container.innerHTML = '<span data-inventory-msg>'+ text +'</span>';
  }

  function msgFromVariant(v){
    if (!v) return '';
    if (!v.available) return TXT.none;
    if (!v.inventory_management || v.inventory_policy === 'continue') return TXT.available;
    const qty = Number(v.inventory_quantity || 0);
    if (qty > 10) return TXT.inStockMany;
    if (qty > 0)  return TXT.inStockFew(qty);
    return TXT.none;
  }

  function readEmbeddedProduct(sectionId){
    try{
      const el = document.getElementById('ProductData-' + sectionId);
      return el ? JSON.parse(el.textContent) : null;
    }catch(e){ return null; }
  }

  async function fetchProductJson(handle){
    try{
      const res = await fetch('/products/' + handle + '.js', {credentials:'same-origin'});
      return await res.json();
    }catch(e){ return null; }
  }

  function closestProductRoot(el){
    return el.closest?.('#ProductInfo-' + el.dataset.sectionId) || document;
  }

  function findVariantInput(root){
    return root.querySelector('input[name="id"]') || document.querySelector('input[name="id"]');
  }

  function currentVariantId(root){
    const input = findVariantInput(root);
    return input && input.value ? String(input.value) : (new URL(location.href)).searchParams.get('variant');
  }

  function bindForContainer(container){
    const sectionId = container.dataset.sectionId;
    const handle    = container.dataset.productHandle;
    let productData = readEmbeddedProduct(sectionId);
    let lastId = null;

    async function ensureProductData(){
      if (!productData || !productData.variants) {
        productData = await fetchProductJson(handle);
      }
    }

    function variantById(id){
      if (!id || !productData) return null;
      const sid = String(id);
      return (productData.variants || []).find(v => String(v.id) === sid) || null;
    }

    async function updateFromRoot(){
      await ensureProductData();
      const root = closestProductRoot(container);
      const id = currentVariantId(root);
      if (id && id !== lastId){
        lastId = id;
        const v = variantById(id);
        setMsg(container, msgFromVariant(v));
      }
    }

    // 1) Primer pintado
    updateFromRoot();

    const root = closestProductRoot(container);

    // 2) Observer: cuando el input hidden cambia su value
    function bindInputObserver(){
      const input = findVariantInput(root);
      if (!input) return;
      const mo = new MutationObserver(updateFromRoot);
      mo.observe(input, {attributes:true, attributeFilter:['value']});
      input.addEventListener('change', updateFromRoot);
    }
    bindInputObserver();

    // 3) Cambios en opciones (radios/selects/swatches)
    root.addEventListener('change', (e)=>{
      const t = e.target;
      if (!t) return;
      if ((t.name && t.name.indexOf('options')===0) || t.matches('select[name^="options"]')) {
        setTimeout(updateFromRoot, 0);
      }
    }, true);

    root.addEventListener('click', (e)=>{
      const t = e.target;
      if (!t) return;
      if (t.closest('.product-form__input')) {
        setTimeout(updateFromRoot, 0);
      }
    }, true);

    // 4) Si el tema re-renderiza la sección y reemplaza nodos, nos re-enganchamos
    const tree = new MutationObserver((muts)=>{
      for (const m of muts){
        if (m.type === 'childList') {
          // si aparece un nuevo input[name="id"] o se reemplaza el bloque, rebind
          if ([...m.addedNodes].some(n => n.nodeType===1 && (n.matches?.('input[name="id"]') || n.querySelector?.('input[name="id"]')))) {
            bindInputObserver();
            updateFromRoot();
            break;
          }
        }
      }
    });
    tree.observe(document.body, {childList:true, subtree:true});

    // 5) Cambios de URL (?variant=) por pushState/replaceState o back/forward
    window.addEventListener('itgp:urlchange', updateFromRoot);

    // 6) Fallback polling suave
    setInterval(updateFromRoot, 500);
  }

  function init(){
    document.querySelectorAll('[data-itgp-inventory]').forEach(bindForContainer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // En el editor de temas, al cargar la sección
  document.addEventListener('shopify:section:load', init);
})();
